/**
 * Configuration for the conversation identifier field.
 * This allows the business logic to use different identifier names
 * (thread_id, project_id, campaign_id, etc.) without changing code.
 */
interface IdentifierConfig {
  /** Field name used in API requests/responses (e.g., "thread_id", "project_id") */
  fieldName: string;

  /** Display name shown in UI (e.g., "Thread", "Project", "Campaign") */
  displayName: string;

  /** Database collection name (configurable: "threads" or "projects") */
  collectionName: string;

  /** URL path segment (configurable: "threads" or "projects") */
  pathSegment: string;
}

/**
 * Get the current identifier configuration from environment variables.
 */
export function getIdentifierConfig(): IdentifierConfig {
  const fieldName = import.meta.env.VITE_CONVERSATION_IDENTIFIER;

  // Derive display name from field name (thread_id → Thread, project_id → Project)
  const displayName = import.meta.env.VITE_CONVERSATION_DISPLAY_NAME ||
    fieldName.replace('_id', '').replace(/^\w/, (c: string) => c.toUpperCase());

  // Get collection name from env (threads or projects)
  const collectionName = import.meta.env.VITE_COLLECTION_NAME || 'threads';

  // Derive path segment from collection name (can be same or different)
  const pathSegment = import.meta.env.VITE_API_PATH_SEGMENT || collectionName;

  return {
    fieldName,
    displayName,
    collectionName,
    pathSegment,
  };
}
